import { useEffect, useState } from "react";
import { BellRing, X } from "lucide-react";
import { toast } from "sonner";
import { useAuthedApi } from "../lib/api";
import { pushSupported, currentSub, enablePush, isIOS, isStandalone } from "../lib/notify";

// One-tap prompt in Chats to turn on background notifications for this device.
export default function PushPrompt() {
  const api = useAuthedApi();
  const [show, setShow] = useState(false);
  const iosHint = !pushSupported() && isIOS() && !isStandalone();

  useEffect(() => {
    if (localStorage.getItem("csm_push_prompt_off")) return;
    if (iosHint) return setShow(true);
    if (!pushSupported() || Notification.permission === "denied") return;
    currentSub().then((s) => setShow(!s || Notification.permission !== "granted")).catch(() => {});
  }, [iosHint]);

  if (!show) return null;
  const close = () => { localStorage.setItem("csm_push_prompt_off", "1"); setShow(false); };
  const on = async () => {
    try { await enablePush(api); toast.success("You'll get notified about new messages & offers"); setShow(false); }
    catch (e) { toast.error(e.message); }
  };
  return (
    <div className="lux-card p-3 mx-4 sm:mx-0 mb-3 flex items-center gap-3" data-testid="push-prompt">
      <BellRing className="w-5 h-5 text-[#D4AF37] shrink-0" />
      <p className="text-xs sm:text-sm flex-1">{iosHint ? "To get message alerts on iPhone: Share → Add to Home Screen, then open the app and turn on notifications." : "Get a notification with sound when a buyer or seller messages you."}</p>
      {!iosHint && <button className="btn-gold text-xs !py-1.5 !px-3" onClick={on} data-testid="push-prompt-enable">Turn on</button>}
      <button onClick={close} aria-label="Dismiss" className="text-gray-400 hover:text-[#E5C158]" data-testid="push-prompt-dismiss"><X className="w-4 h-4" /></button>
    </div>
  );
}
